import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ExternalLink } from 'lucide-react';

const Services: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="services" className="py-20 md:py-32 bg-gradient-to-b from-[#1b1512] to-[#231a15] relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="text-center mb-14 md:mb-24"
          >
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.2, ease: "easeOut" }}
              className="text-4xl md:text-7xl font-light mb-8 md:mb-12 leading-none tracking-tight text-amber-50"
            >
              Premium
              <br />
              <span className="font-normal text-amber-300/80">Hizmetlerimiz</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.4, ease: "easeOut" }}
              className="text-base sm:text-lg md:text-2xl text-amber-100/75 mb-10 md:mb-16 max-w-3xl mx-auto leading-relaxed font-light"
            >
              Uber Eats Trendyol Go ile online siparislerinizi hizli ve guvenli sekilde ulastiriyoruz
            </motion.p>
          </motion.div>

          {/* Service Highlight */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.6, ease: "easeOut" }}
            className="mb-16 md:mb-32"
          >
            <motion.div
              whileHover={{ y: -4 }}
              className="relative overflow-hidden rounded-3xl border border-amber-100/20 bg-gradient-to-br from-amber-50/[0.06] via-[#231a15] to-[#120e0c] p-6 md:p-12 shadow-2xl shadow-black/30"
            >
              <div className="absolute -top-24 -right-20 w-56 h-56 rounded-full bg-amber-200/10 blur-3xl" />
              <div className="absolute -bottom-20 -left-20 w-48 h-48 rounded-full bg-amber-100/10 blur-3xl" />

              <div className="relative z-10">
                <span className="inline-block rounded-full border border-amber-200/35 px-4 py-1 text-xs tracking-[0.22em] uppercase text-amber-200/90 mb-6">
                  Online Siparis
                </span>
                <h3 className="text-2xl md:text-4xl font-light text-amber-50 mb-4">
                  Uber Eats Trendyol Go
                </h3>
                <p className="text-amber-100/75 text-base md:text-lg font-light leading-relaxed max-w-2xl">
                  En sevilen urunlerimizden eksi mayali ekmeklere kadar secili lezzetlerimizi Uber Eats Trendyol Go uzerinden kolayca siparis verebilirsiniz.
                </p>

                <motion.a
                  href="https://tgoyemek.com/restoranlar/392694#bu-restoranin-en-sevilenleri"
                  target="_blank"
                  rel="noreferrer"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="mt-7 inline-flex items-center gap-2 rounded-full bg-amber-100 text-[#1d140f] px-5 py-3 text-sm md:text-base font-medium hover:bg-amber-200 transition-colors"
                >
                  Uber Eats Trendyol Go'da Gor
                  <ExternalLink size={18} />
                </motion.a>
              </div>
            </motion.div>
          </motion.div>

          {/* Manifesto */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.8, ease: "easeOut" }}
            className="text-center"
          >
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 1, ease: "easeOut" }}
              className="text-xl md:text-4xl font-light text-amber-100/85 leading-relaxed max-w-4xl mx-auto"
            >
              "Müşteri memnuniyeti bizim en büyük 
              <br />
              başarımızdır."
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services; 